// Runtime PWA setup: injects a web app manifest and registers a minimal
// service worker so the app becomes installable on mobile devices.
// (public/index.html cannot be edited in this environment.)

const ICON_SVG = encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
  <rect width="512" height="512" rx="96" fill="#0f172a"/>
  <path d="M256 392 L150 282 C108 240 118 176 174 162 C212 153 244 173 256 202 C268 173 300 153 338 162 C394 176 404 240 362 282 Z" fill="#ec4899"/>
</svg>`)

const ICON_URL = `data:image/svg+xml,${ICON_SVG}`

function injectMeta() {
  const ensure = (selector: string, create: () => HTMLElement) => {
    if (!document.head.querySelector(selector)) {
      document.head.appendChild(create())
    }
  }

  ensure('meta[name="viewport"]', () => {
    const m = document.createElement('meta')
    m.name = 'viewport'
    m.content =
      'width=device-width, initial-scale=1, viewport-fit=cover, maximum-scale=1'
    return m
  })
  ensure('meta[name="theme-color"]', () => {
    const m = document.createElement('meta')
    m.name = 'theme-color'
    m.content = '#0f172a'
    return m
  })
  ensure('meta[name="apple-mobile-web-app-capable"]', () => {
    const m = document.createElement('meta')
    m.name = 'apple-mobile-web-app-capable'
    m.content = 'yes'
    return m
  })
  ensure('meta[name="apple-mobile-web-app-status-bar-style"]', () => {
    const m = document.createElement('meta')
    m.name = 'apple-mobile-web-app-status-bar-style'
    m.content = 'black-translucent'
    return m
  })
  ensure('link[rel="apple-touch-icon"]', () => {
    const l = document.createElement('link')
    l.rel = 'apple-touch-icon'
    l.href = ICON_URL
    return l
  })
}

function injectManifest() {
  let link = document.head.querySelector<HTMLLinkElement>(
    'link[rel="manifest"]',
  )
  if (!link) {
    link = document.createElement('link')
    link.rel = 'manifest'
    document.head.appendChild(link)
  }
  // Point to the real manifest file shipped at /manifest.json
  link.href = '/manifest.json'
}

function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return

  const swCode = `
    const CACHE = 'steinkarten-v1';
    self.addEventListener('install', (e) => { self.skipWaiting(); });
    self.addEventListener('activate', (e) => { e.waitUntil(self.clients.claim()); });
    self.addEventListener('fetch', (e) => {
      e.respondWith(
        fetch(e.request).catch(() => caches.match(e.request))
      );
    });
  `
  const blob = new Blob([swCode], { type: 'text/javascript' })
  const swUrl = URL.createObjectURL(blob)
  navigator.serviceWorker.register(swUrl).catch(() => {
    /* registration may fail in sandboxed previews — safe to ignore */
  })
}

export function setupPWA() {
  injectMeta()
  injectManifest()
  if (document.readyState === 'complete') {
    registerServiceWorker()
  } else {
    window.addEventListener('load', registerServiceWorker)
  }
}
